var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.67,
    height: 44.2,
    viewBox: "0 0 36.67 44.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "m36.67,44.2H0v-8.94L13.97,0h8.73l13.97,35.26v8.94Zm-20.44-23.81l-4.66,11.77c-.46,1.16.11,2.48,1.27,2.94.26.1.54.16.83.16h9.32c1.25,0,2.26-1.02,2.26-2.27,0-.28-.05-.56-.16-.83l-4.66-11.77c-.46-1.16-1.78-1.73-2.94-1.27-.58.23-1.04.69-1.27,1.27",
    fill: "#ede9e4",
    strokeWidth: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLt);
export default __webpack_public_path__ + "static/media/icon-lt.ed94bd8ded3eb99cce4c79d5d3f7fc61.svg";
export { ForwardRef as ReactComponent };